
const DefaultStore = {
    columns: []
}

export default DefaultStore